import React from 'react'
import { AnalyticsTracker } from '../analytics/tracking'

export type AnalyticsContext = {
    Analytics: AnalyticsTracker
}

const DefaultAnalyticsContext: AnalyticsContext = {
    Analytics: new AnalyticsTracker(),
}

export const AnalyticsContext = React.createContext(DefaultAnalyticsContext)
